import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { successSchema } from '../../utils';
import { ZGiftcloudRewardEventNotification } from './models';

const c = initContract();

export const publicGiftcloudContract = c.router(
  {
    processRewardEventNotification: {
      method: 'POST',
      path: '/process-reward-event-notification',
      body: ZGiftcloudRewardEventNotification,
      responses: {
        200: successSchema,
        400: z.object({
          message: z.string(),
        }),
      },
      summary:
        'Webhook for receiving reward event notifications from Giftcloud',
    },
  },
);
